import stores from 'cd-eft/models/Stores';
import { action } from 'mobx';
import { TerraceDesignToolsController } from 'cd-eft/services/eftSetApi';
import { EftProjUserInputController } from 'cd-eft/services/eftPrjAdminApi';
import { DesignContainerVM } from 'cd-eft/components/Design/DesignContainer/DesignContainerVM';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { mdiCalculator, mdiCalculatorVariantOutline, mdiPencilRulerOutline, mdiWaves } from '@mdi/js';
import { appConfig } from 'cd-eft/config/AppConfig';
import { TerraceUiState, UIState } from 'cd-eft/models/Stores/TerraceDesignStore';
import { GraphicsLayer } from 'cd-eft/utils/esriTypes';
import { AppConstants } from 'cd-eft/appConstants';

const { terraceDesignStore, designStore } = stores.AppStore;

export class TerraceContainerVM {

  constructor() {}

  @action onClickEdit = () => {
    terraceDesignStore.addTerraceClicked = !terraceDesignStore.addTerraceClicked;

    if (terraceDesignStore.addTerraceClicked /* && !hasProject() */) {
      //this.noProjectMessage()
    }
  };
  @action.bound async getErrors() {
    terraceDesignStore.notifications.unsavedEditsClosePage = await MessageCenter.addErrorLabelFromCode('Common_13');
  }
}

export const getTerraceData = async (terraceId, mapView) => {
  terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId = terraceId;
  designStore.designElementTypeId = appConfig.hardCodes.designElementTypeTerrace; //To enable ToolBar on the map for Terrace
  if (terraceId) {
    designStore.setLoader("  ");
    try {
      // BASE-URL/terracedesign/getTerraceBasicInfo/{alignElementDesignParamsId}
      // const response = await TerraceDesignToolsController.getTerraceBasicInfoUsingGET(terraceId);
      const responseForBasicInfo = await TerraceDesignToolsController.getTerraceInputsByAlignedElementDesignParamsIdUsingGET(
        terraceId
      );
      if (responseForBasicInfo && responseForBasicInfo.data) {
        const dataForBasicInfo = responseForBasicInfo.data;
        if (dataForBasicInfo.status === 'Success') {
          terraceDesignStore.terraceType = dataForBasicInfo.designElementTypeId!;
          terraceDesignStore.alignmentDesignElementJsonId = dataForBasicInfo.alignmentJsonId!;
          terraceDesignStore.terraceDesignObject.alignedFeatureName = dataForBasicInfo.terraceName!;
        } else {
          await MessageCenter.addNotificationFromCode(dataForBasicInfo.status!);
        }
      } else {
        throw new Error('Failed to generate channel data from the service.');
      }

      if(terraceDesignStore.uiState === 'ChannelDesignSurface'){
        await generateSurface(terraceId, mapView);
      }
      else if(terraceDesignStore.uiState === undefined) {
        const response = await EftProjUserInputController.getDesignUiStateUsingGET1(designStore.projectsStore.currentSessionId, terraceId);
        if (response.data.errorCode === "Success") {

          if (response.data.alignedElementUiStateDto && response.data.alignedElementUiStateDto.uiSettingsDto) {

            const uiSettingsDto = response.data.alignedElementUiStateDto.uiSettingsDto;
            const savedProfileSettingsForm = terraceDesignStore.savedProfileSettingsForm;
            savedProfileSettingsForm.input.fineGrid = uiSettingsDto.fineGrid ? uiSettingsDto.fineGrid : Math.trunc(25.0);
            savedProfileSettingsForm.input.sampleInterval = uiSettingsDto.sampleInterval ? uiSettingsDto.sampleInterval : 2;
            savedProfileSettingsForm.input.verticalInterval = uiSettingsDto.verticalInterval ? uiSettingsDto.verticalInterval : 5
            savedProfileSettingsForm.checked.showFineGrid = uiSettingsDto.showCoord ? uiSettingsDto.showCoord : false;

          }
          const uiStateType = response.data.uiStateType;
          if (uiStateType && TerraceUiState[uiStateType]) {
            terraceDesignStore.uiState = uiStateType as UIState;
            if(terraceDesignStore.uiState === 'ChannelDesignSurface'){
              await generateSurface(terraceId, mapView);
            }

          }
        }
      }
      if (!terraceDesignStore.summaryInfo.terraceNameExists) {
        // call summary list API
        const response = await TerraceDesignToolsController.getTerraceDesignSummariesBySessionUuidUsingGET(designStore.projectsStore.currentSessionId);
        if (response && response.data) {
          const target = response.data.find((item) => +item.alignedElementDesignParamsId! === +terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId);
          terraceDesignStore.summaryInfo = {
            channelLength: target?.length ? target.length : 0,
            templateName: target?.defaultTemplate ? target.defaultTemplate : '',
            terraceNameExists: target !== undefined
          }
        }
      }
    }
    catch (e) {
      console.error(e)
    } finally{
      designStore.setLoader("");
    }
  }
}

export const generateSurface = async (terraceId, mapView) => {
  let errorCode = "";
  try {
      if (!(terraceDesignStore.terraceDesignObject && terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId)) {
          throw new Error("Invalid state: no current terrace design ID.");
      }
      // const designId = terraceDesignStore.terraceDesignObject.alignedElementDesignParametersId;
      let channelResult: any;
      let turnOnTin: boolean = false;

      const response = await TerraceDesignToolsController.generateTerraceDesignSurfaceByAlignedElementIdUsingGET(terraceId);
      if (response && response.data && response.data.terraceStructureShapeDTO) {
        if (response.data.terraceStructureShapeDTO["status"]) {
          errorCode = response.data.terraceStructureShapeDTO["status"];
          throw new Error("Failed to generate channel data from the service.");
        } else {
          channelResult = response.data;
          if ((!channelResult.contourLines || channelResult.contourLines.length === 0) && channelResult.tinTriangles) {
            turnOnTin = true;
          }
        }
      } else {
        throw new Error("Failed to generate channel data from the service.");
      }

      if (channelResult.tinTriangles || channelResult.contourLines) {
        const result = await DesignContainerVM.loadSurfaceFromData(
          channelResult.tinTriangles,
          undefined,
          channelResult.contourLines,
          undefined,
          undefined,
          true
        );
        if(result) {
          await terraceDesignStore.handleUiStateUpdate({ uiStateType: TerraceUiState.ChannelDesignSurface.string });
        }
        if (turnOnTin && mapView) {
          const DesignedTinTrianglesLayer = mapView.map.findLayerById(AppConstants.DesignedTinTrianglesLayerId) as GraphicsLayer;
          if (DesignedTinTrianglesLayer) {
              DesignedTinTrianglesLayer.visible = true;
          }
        }
      }

  } catch (e) {
    throw new Error("Failed to generate designed surface.");
  } finally {
    terraceDesignStore.generateTerraceSurface = false;
  }
}


export const terraceTypes = {
  20: 'Gradient',
  21: 'Level',
  22: 'Storage',
  23: 'Wascob',
};

export const terraceTitles = {
  input: 'Terrace Inputs',
  template: 'Terrace Template',
  design: 'Terrace Design',
  'storage-calculation': 'Storage Calculation',
  'alignment-view': 'Terrace Design',
};

export const terraceNavigation = [
  {
    name: 'input',
    title: 'Terrace Inputs',
    icon: mdiWaves,
    link: `input`,
  },
  {
    name: 'template',
    title: 'Terrace Template',
    icon: mdiCalculator,
    link: `template`,
  },
  {
    name: 'design',
    title: 'Terrace Design',
    icon: mdiPencilRulerOutline,
    link: `design`,
  },
  {
    name: 'storage-calculation',
    title: 'Storage Calculation',
    icon: mdiCalculatorVariantOutline,
    link: `storage-calculation`,
  },
];
